import React from "react";

const PendingSPopupHw = ({ setPendingPopup1 }) => {
  return (
    <>
      <div className=" successful_preview_transprant_body ">
        <div className=" p-2 successful_preview_container shadow">
          <img src="/images/pending_icon.svg" alt="" />
          <span className=" my-4 successfully_message">
            Student has not submitted the homework.
          </span>
          <div>
            <button
              className="successfull_okay_btn"
              onClick={(e) => setPendingPopup1(false)}
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingSPopupHw;
